const SWOT_TOGGLE = {
    1: 'strengths',
    2: 'weaknesses',
    3: 'opportunities',
    4: 'threats',
}

const SWOT_TAB = {
    STRENGTHS: 'strengths',
    WEAKNESSES: 'weaknesses',
    OPPORTUNITIES: 'opportunities',
    THREATS: 'threats',
}

const SWOT_DATA_TYPE = {
    CRITICAL: 50,
    AVERAGE: 75,
    ABOVE_AVERAGE: 90,
}

export const SWOT_DATA_INFO = {
    ATTEMPT_RATE: 'Attempt Rate',
    ACCURACY_RATE: 'Accuracy Rate',
  }
  

export {SWOT_TOGGLE, SWOT_TAB, SWOT_DATA_TYPE};